<!-- App.vue or Layout.vue -->
<template>
  <SidebarNav>
    <router-view />
  </SidebarNav>
</template>

<script setup lang="ts">
import SidebarNav from '@/views/tools/layout/SidebarNav.vue'
</script>